export const NPX_HEADER_TIMEZONE_NAME = 'X-Client-TimeZone';
export const NPX_COOKIE_LOCALE_NAME = 'NPX-CLIENT-LOCALE';
export const NPX_COOKIE_TIMEZONE_NAME = 'NPX-CLIENT-TIMEZONE';
export const NPX_COOKIE_LOCALE_TIMEZONE_NAME = 'NPX-CLIENT-LOCALE-TIMEZONE';
